import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CriteriaCardView from "./CriteriaCardView";
import {
    replaceCriteriaSelection,
    selectTemplate,
    toggleCriterionSelection
} from '../../../Actions/stage.action';
import './criteria.css';

const Criteria = ({
    openModalTrigger = 0,
    animationCycle = 0,
    povTransitioning = false,
    povTransitionPartyName = '',
    comparison,
}) => {
    const dispatch = useDispatch();
    const {
        criteriaListe: criteria,
        templates,
        selectedTemplate,
        selectedCriteria = []
    } = useSelector((state) => state.stage);

    const handleTemplateChange = (templateId) => {
        if (!templateId) {
            dispatch(selectTemplate(null));
            dispatch(replaceCriteriaSelection([]));
            return;
        }
        const template = templates.find(t => t.id === templateId);
        dispatch(selectTemplate(template));
        dispatch(replaceCriteriaSelection(
            template.criteria.map(c => ({ id: c.id, ref: [] }))
        ));
    };

    const safeCriteria = Array.isArray(criteria) ? criteria : [];

    return (
        <div className="criteria-shell">
            <CriteriaCardView
                criteria={safeCriteria}
                templates={templates}
                selectedTemplate={selectedTemplate}
                selectedCriteria={selectedCriteria}
                onTemplateChange={handleTemplateChange}
                onToggleSelection={(criterionId) => dispatch(toggleCriterionSelection(criterionId))}
                openModalTrigger={openModalTrigger}
                animationCycle={animationCycle}
                povTransitioning={povTransitioning}
                povTransitionPartyName={povTransitionPartyName}
                comparison={comparison}
            />
        </div>
    );
};

export default Criteria;
